import { MDBBtn, MDBDatatable, MDBIcon, MDBSpinner } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import {
  getAllInvoicesStatements,
  handleDownloadInvoice,
  handleViewInvoice,
} from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";

const BillingInvoice = ({ groupid, isActive }) => {
  const [isloading, setIsloading] = useState(false);
  const [InStmtList, setInStmtList] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (groupid && isActive) {
      getInvoiceStatementList();
    }
  }, [groupid, isActive]);

  async function getInvoiceStatementList() {
    try {
      setIsloading(true);
      const response = await getAllInvoicesStatements(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        groupid
      );
      const rawData = await response.json();
      setIsloading(false);
      console.log("Invoices list :::::::::::::: " + JSON.stringify(rawData));
      if (response.status === 200) {
        const data = rawData?.billing_invoices.map((group) => ({
          groupInfo: group,
          date: group?.month
            ? parseInt(group?.month) < 10
              ? `0${group.month}-${group.year}`
              : `${group.month}-${group.year}`
            : "",

          action: (
            <div className="d-flex align-items-center ms-2">
              <div
                className="custom-hover-bg p-1 cursor-pointer View"
                onClick={(e) => handleViewPDF(e, group)}
              >
                <MDBIcon fas icon="eye" color="primary" className=" px-2 py-1 fs-5" />
              </div>
              <div
                className="custom-hover-bg p-1 cursor-pointer download ms-3"
                onClick={(e) => handleDownloadPDF(e, group)}
              >
                <MDBIcon
                  fas
                  icon="download"
                  color="primary"
                  className=" px-2 py-1 fs-5"
                />
              </div>
            </div>
          ),
        }));

        setInStmtList(data);
      } else if (response.status === 500) {
        // setInternalError(true);
      } else {
        // navigate("/");
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
    } finally {
      setIsloading(false);
    }
  }

  const invoiceTableData = {
    columns: [
      { label: "Date", field: "date" },
      { label: "Actions", field: "action", sort: false },
    ],
    rows: InStmtList,
  };

  const handleViewPDF = (e, info) => {
    e.preventDefault();
    e.stopPropagation();
    handleView(info);
  };

  const handleView = async (info) => {
    try {
      let apiResponse = await handleViewInvoice(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        groupid,
        info.file_key
      );
      console.log("apiResponse ::::::::::::::: ", apiResponse);
      // debugger;

      let filename = "";
      if (apiResponse.status == 200) {
        const blob = await apiResponse.blob();

        // Create a URL and open it in a new tab
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        // setInternalError(true);
      }
    } catch (error) {
      console.log("Error ::::::::: " + error);
    }
  };

  const handleDownloadPDF = (e, info) => {
    e.preventDefault();
    e.stopPropagation();
    handleDownload(info);
  };

  const handleDownload = async (info) => {
    try {
      let apiResponse = await handleDownloadInvoice(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        groupid,
        info.file_key
      );
      console.log("apiResponse ::::::::::::::: " + JSON.stringify(apiResponse));
      // debugger;

      let filename = "";
      if (apiResponse.status == 200) {
        const contentDisposition = apiResponse.headers.get(
          "Content-Disposition"
        );
        setTimeout(() => {
          setIsloading(false);
        }, 1000);
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }
        const fileUrl = URL.createObjectURL(await apiResponse.blob());
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        // setInternalError(true);
      }
    } catch (error) {
      console.log("Error ::::::::: " + error);
    }
  };

  return (
    <div className="billing-invoice-datatable">
      <MDBDatatable
        pagination={false}
        data={invoiceTableData}
        sortField="Billing Groups"
      />

      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}

      <Tooltip anchorSelect=".download" place="right" className="exampleTooltip">
        Download
      </Tooltip>
      <Tooltip anchorSelect=".View" place="left" className="exampleTooltip">
        View
      </Tooltip>
    </div>
  );
};

export default BillingInvoice;
